<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Προσθήκη Χρήστη</h4>
          <p class="card-title-desc">
            Συμπληρώστε τα παρακάτω πεδία για προσθήκη χρήστη
          </p>

          <form-wizard color="#556ee6" @on-complete="submitForm" nextButtonText="Επόμενο" backButtonText="Προηγούμενο"
            finishButtonText="Τέλος" stepSize="sm" @on-validate="handleValidation" @on-error="handleErrorMessage">
            <div v-if="errorMsg">
              <b-alert show dismissible variant="danger">{{
                errorMsg
              }}</b-alert>
            </div>
            <tab-content icon="mdi mdi-account-circle" :before-change="validateFirstTab">
              <!-- <tab-content> -->
              <div class="row">
                <h3 class="card-title" style="text-decoration:underline;">
                  Προσωπικά Στοιχεία Χρήστη
                </h3>
                <hr />

                <div class="col-md-4">
                  <div class="mb-3">
                    <label>Username**</label>
                    <input v-model="firstTabModels.username" type="text" required class="form-control"
                      placeholder="Username" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>Όνομα*</label>
                    <input v-model="firstTabModels.firstName" required type="text" class="form-control"
                      placeholder="Όνομα" />
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label>Επίθετο*</label>
                    <input v-model="firstTabModels.lastName" required type="text" class="form-control"
                      placeholder="Επίθετο" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>Πατρώνυμο*</label>
                    <input v-model="firstTabModels.fathersName" required type="text" class="form-control"
                      placeholder="Πατρώνυμο" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>Μητρώνυμο*</label>
                    <input v-model="firstTabModels.mothersName" required type="text" class="form-control"
                      placeholder="Μητρώνυμο" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label>Email*</label>
                    <input required v-model="firstTabModels.email" type="email" class="form-control"
                      placeholder="Email" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-2">
                    <label>Τηλέφωνο Επικοινωνίας</label>
                    <input v-model="phone" type="text" class="form-control" placeholder="Τηλέφωνο" maxlength="16" />

                    <strong style="color:red">{{ phoneFieldErrorMsg }}</strong>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-2">
                    <label>Hrms Χρήστη</label>
                    <input v-model="hrmsPersonID" type="text" class="form-control" placeholder="Hrms" maxlength="16" />

                    <strong style="color:red">{{ hrmsFieldErrorMsg }}</strong>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-2">
                    <label>Αριθμός Δελτίου Ταυτότητας</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-2">
                    <label>Α.Φ.Μ.</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-2">
                    <label>Α.Μ.Κ.Α.</label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </tab-content>

            <tab-content :before-change="validateSecondTab">
              <!-- <tab-content> -->
              <div class="row">
                <h3 class="card-title" style="text-decoration:underline;">
                  Τμήμα και Ρόλος Χρήστη
                </h3>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="mt-3">Τμήμα*</label>
                    <multiselect v-model="departmentValue" track-by="id" label="name" :options="departmentNames"
                      :multiple="true" placeholder="Επιλέξτε Τμήμα" selectLabel="Eπιλογή Τμήματος"
                      selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή"></multiselect>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label class="mt-3">Ρόλος*</label>
                  <multiselect required track-by="role_id" label="role_name" v-model="roleValue" :options="rolesOptions"
                    placeholder="Επιλέξτε Ρόλο" selectLabel="Eπιλογή Ρόλου" selectedLabel="Επιλέχθηκε"
                    deselectLabel="Αποεπιλογή"></multiselect>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="mt-3">Δευτερεύον ρόλος</label>
                    <input v-model="secondaryRole" required type="text" class="form-control"
                      placeholder="Δευτερεύον ρόλος" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mb-3">
                    <label class="mt-3">Σχέση Εργασίας*</label>
                    <multiselect required v-model="empRealtionshipValue" :options="employmentRelationshipOptions"
                      track-by="id" label="name" placeholder="Επιλέξτε Σχέση Εργασίας"
                      selectLabel="Eπιλογή Σχέση Εργασίας" selectedLabel="Επιλέχθηκε" deselectLabel="Αποεπιλογή">
                    </multiselect>
                  </div>
                </div>
                <hr />

                <div class="row">
                  <h4 class="card-title">Σύμβαση</h4>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <label class="mt-3">Από*</label>
                      <b-form-input id="example-input" v-model="contract.contractStartDate" type="date"
                        placeholder="DD-MM-YYYY" format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="mb-3">
                      <label class="mt-3">Μέχρι*</label>
                      <b-form-input id="example-input" v-model="contract.contractEndDate" type="date"
                        placeholder="DD-MM-YYYY" format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                    </div>
                  </div>

                  <div class="col-md-5">
                    <div class="mb-3">
                      <label>Σχόλιο</label>
                      <input v-model="contract.comment" type="text" class="form-control" placeholder="Σχόλιο" />
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
            <tab-content :before-change="validateThirdTab">
              <!-- <tab-content> -->
              <div class="row">
                <h3 class="card-title" style="text-decoration:underline;">
                  Παρουσιολόγιο
                </h3>
                <div class="col-md-6">
                  <!-- <div class="mb-3">
                    <label class="mt-3">Ρολόι Παρουσίας*</label>
                    <multiselect
                      required
                      v-model="deviceValue"
                      :options="devicesOptions"
                      placeholder="Επιλέξτε Ρολόι"
                      selectLabel="Eπιλογή Ρολόι"
                      selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"
                    ></multiselect>
                  </div> -->
                  <div class="col-md-6">
                    <div class="mt-2">
                      <label>Αριθμός Κάρτας*</label>
                      <input v-model="cardNumber" required type="text" class="form-control"
                        placeholder="Αριθμός Κάρτας Χρήστη" />
                      <strong style="color:red">{{
                        cardNumberErrorMsg
                      }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>

            <tab-content icon="mdi mdi-check" :before-change="validateFourthTab">
              <!-- <tab-content> -->
              <div class="row">
                <h3 class="card-title" style="text-decoration:underline;">
                  Ωράριο Εργασίας
                </h3>

                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="mt-3">Από*</label>
                    <b-form-input id="example-input" v-model="startDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="mb-3">
                    <label class="mt-3">Μέχρι*</label>
                    <b-form-input id="example-input" v-model="endDate" type="date" placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY" autocomplete="off"></b-form-input>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="mt-3">
                    <label>Ημέρες</label>
                    <multiselect required v-model="weekdaySelected" :options="weekdayOptions" multiple
                      placeholder="Επιλέξτε Ημέρες" selectLabel="Eπιλογή Ημέρα" selectedLabel="Επιλέχθηκε"
                      deselectLabel="Αποεπιλογή"></multiselect>
                  </div>
                </div>
                <div v-for="(applicant, idx) in workingSchedule" :key="idx" class="row">
                  <!-- <div class="col-md-4">
                    <div class="mb-3">
                      <label class="mt-3">Ημέρα</label>
                      <multiselect
                        required
                        v-model="workingSchedule[idx].weekday"
                        :options="weekDayOptions"
                        placeholder="Επιλέξτε Μέρα"
                      ></multiselect>
                    </div>
                  </div> -->
                  <div class="col-md-4">
                    <div class="mt-3">
                      <label>Ώρα Έναρξης</label>
                      <br />
                      <date-picker v-model="workingSchedule[idx].startTime" format="HH:mm" value-type="format"
                        type="time" placeholder="hh:mm"></date-picker>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mt-3">
                      <label>Ώρα Λήξης</label>
                      <br />
                      <date-picker v-model="workingSchedule[idx].endTime" format="HH:mm" value-type="format" type="time"
                        placeholder="hh:mm"></date-picker>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mt-3">
                      <label>Νυχτερινό ωράριο</label>
                      <b-form-checkbox v-model="workingSchedule[idx].is_night_shift" class="mb-3 custom-checkbox"
                        plain></b-form-checkbox>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="col-sm-2">
                        <button v-show="idx == workingSchedule.length - 1 &&
                          workingSchedule.length < 2
                          " class="btn btn-primary" @click.prevent="addFormField(idx)">
                          <i class="bx bx-calendar-event ">Προσθήκη</i>
                        </button>
                        <button v-show="workingSchedule.length > 1" class="btn btn-danger"
                          @click.prevent="removeFormField(idx)">
                          <i class="bx bx-calendar-event ">Αφαίρεση</i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </div>
      <p>Τα πεδία με * είναι υποχρεωτικά</p>
      <p>
        **Το username θα πρέπει να έχει τη μορφή
        <strong style="color:#556ee6">onoma.epitheto</strong>
      </p>
      <!-- end card -->
    </div>
    <!-- end col-->
  </div>
  <!-- end card -->
</template>

<script>
import Multiselect from "vue-multiselect";
import { FormWizard, TabContent } from "vue-form-wizard";
// import session from "../../../../api/session";
import { translateRole } from "../../../../translate_roles";
import { mapState } from "vuex";
import DatePicker from "vue2-datepicker";
import { weekDays } from "../utils";
import { isUsernameExists, isCardNmberExists } from "./form_submit_by_step";
import moment from "moment";
import session from "../../../../api/session";

export default {
  components: {
    Multiselect,
    FormWizard,
    TabContent,
    DatePicker,
  },
  data() {
    return {
      workingSchedule: [
        {
          startTime: "07:00",
          endTime: "15:00",
          is_night_shift: false,
        },
      ],
      departmentOptionals: [],
      departmentValue: "",
      secondaryRole: "",
      roleValue: "",
      empRealtionshipValue: "",
      errorMsg: "",
      deviceValue: "",
      phoneFieldErrorMsg: "",
      hrmsFieldErrorMsg: "",
      cardNumber: "",
      cardNumberErrorMsg: "",

      contract: {
        contractStartDate: moment().format("yyyy-MM-DD"),
        contractEndDate: moment()
          .add(30, "years")
          .format("yyyy-MM-DD"),
        comment: "",
      },

      firstTabModels: {
        username: "",
        firstName: "",
        lastName: "",
        fathersName: "Πατρώνυμο",
        mothersName: "Μητρώνυμο",
        email: "",
      },
      phone: "",
      hrmsPersonID: "",
      startDate: "",
      endDate: "",
      err: "",
      completeSubmitForm: {},
      weekdaySelected: ["Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή"],
    };
  },

  computed: {
    ...mapState("utils", [
      "devices",
      "departments",
      "employmentRelationShips",
      "departmentOptions",
      "roleChoices",
      "roles",
    ]),

    employmentRelationshipOptions() {
      return this.employmentRelationShips.map((e) => {
        return { id: e.id, name: e.title };
      });
    },
    departmentNames() {
      return this.departmentOptions.map((e) => {
        return { id: e.id, name: e.department_parent_name };
      });
    },
    // return this.departments.map((e) => {
    //   if (e.parent_name === null) {
    //     return e.name;
    //   } else {
    //     return `${e.parent_name}/${e.name}`;
    //   }
    // });
    rolesOptions() {
      return this.roleChoices;

      // return roles.map((e) => e.name);
    },

    devicesOptions() {
      if (this.devices.length > 0) {
        return this.devices.map((e) => e.device_name);
      } else return [];
    },
    weekdayOptions() {
      return weekDays.map((e) => e.weekday);
    },
  },

  watch: {
    phone(v) {
      if (isNaN(v)) {
        this.phoneFieldErrorMsg = "Παρακαλώ μόνο αριθμούς";
      } else if (v.length > 15) {
        this.phoneFieldErrorMsg = "Παρακαλώ εισάγετε αριθμό τηλεφώνου ΟΧΙ iban";
      } else {
        this.phoneFieldErrorMsg = "";
      }
    },

    cardNumber(v) {
      if (isNaN(v)) {
        this.cardNumberErrorMsg = "Παρακαλώ μόνο αριθμούς";
      } else {
        this.cardNumberErrorMsg = "";
      }
    },
    hrmsPersonID(v) {
      if (isNaN(v)) {
        this.hrmsFieldErrorMsg = "Παρακαλώ μόνο αριθμούς";
      } else {
        this.hrmsFieldErrorMsg = "";
      }
    },
  },
  methods: {
    addFormField() {
      this.workingSchedule.push({ start_time: null, end_time: null });
    },
    removeFormField(index) {
      this.workingSchedule.splice(index, 1);
    },

    translateRole,
    handleValidation(isValid, tabIndex) {
      console.log("Tab: " + tabIndex + " valid: " + isValid);
    },

    submitForm() {
      // this.$emit("completed", this.completeSubmitForm);

      const personSchedule = [];
      this.completeSubmitForm.schedule.forEach((element) => {
        personSchedule.push({
          start_time: element.startTime,
          end_time: element.endTime,
          start_date: this.completeSubmitForm.schedule.startDate,
          end_date: this.completeSubmitForm.schedule.endDate,
          weekdays: this.completeSubmitForm.schedule.weekdays,
          is_night_shift: element.is_night_shift,
        });
      });

      session
        .post("api/user/create/", {
          user: {
            username: this.completeSubmitForm.user.username,
            first_name: this.completeSubmitForm.user.firstName,
            last_name: this.completeSubmitForm.user.lastName,
            email: this.completeSubmitForm.user.email,
          },
          person_device_identity: {
            card_number: this.completeSubmitForm.card
              .map((e) => e.cardNumber)
              .join(""),
            // card_number: "123123",
          },
          department: this.completeSubmitForm.departments,
          person_contract: {
            start_date: this.completeSubmitForm.contract.contractStartDate,
            end_date: this.completeSubmitForm.contract.contractEndDate,
            comments: this.completeSubmitForm.contract.comment,
          },
          working_schedule: personSchedule,
          fathers_name: this.completeSubmitForm.user.fathersName,
          mothers_name: this.completeSubmitForm.user.mothersName,
          phone: this.completeSubmitForm.phone,
          role: this.completeSubmitForm.roles,
          secondary_role: this.completeSubmitForm.secondaryRole,
          hrms_person_id: this.completeSubmitForm.hrmsPersonID,
          relationship: this.completeSubmitForm.relationship,
        })
        .then(() => {
          this.$store.dispatch("people/fetchHomeBanner");
          this.$store.dispatch("utils/fetchPeopleOptionFields", {
            peopleFilter: { department: "" },
          });
          this.$emit("completed");
        })
        .catch((e) => {
          console.log(e.response.data);
          this.errorMsg = e.response.data;
          setTimeout(() => {
            this.errorMsg = "";
          }, 3000);
        });
    },

    handleErrorMessage(errorMsg) {
      this.errorMsg = errorMsg;
    },

    validateFirstTab() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const mailRegex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
          if (!mailRegex.test(this.firstTabModels.email)) {
            reject("Παρακαλώ εισάγετε σωστό email");
          }
          // const usernameRegex = /^[a-zA-Z0-9]+$/;
          // if (!usernameRegex.test(this.firstTabModels.username)) {
          //   reject("Παρακαλώ εισάγετε σωστό username");
          // }
          for (let key in this.firstTabModels) {
            if (this.firstTabModels[key].length == 0) {
              console.log(
                key,
                this.firstTabModels[key].length,
                this.firstTabModels[key]
              );
              reject("Παρακαλώ συπμληρώστε ολα τα απαραίτητα πεδια ");
            }
          }
          if (this.phoneFieldErrorMsg) {
            reject("Παρακαλώ βάλτε σωστό τηλέφωνο");
          }
          if (this.phone.length > 0) {
            this.firstTabModels["phone"] = this.phone;
          }
          if (this.hrmsPersonID) {
            this.firstTabModels["hrmsPersonID"] = this.hrmsPersonID;
          }

          this.completeSubmitForm["user"] = this.firstTabModels;

          isUsernameExists(this.completeSubmitForm).then((resp) => {
            if (resp.data.results.length > 0) {
              reject(
                "Υπάρχει χρήστης με ίδιο username. Παρακαλώ εισάγετε νέο."
              );
            } else {
              resolve(true);
            }
          });

          // resolve(true);
        });
      }, 1000);
    },

    validateSecondTab() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          console.log(this.departmentValue);

          console.log(this.roleValue);

          if (this.departmentValue.length == 0) {
            reject("Παρακαλώ επιλέξτε Τμήμα");
          }
          if (this.roleValue.length == 0) {
            reject("Παρακαλώ επιλέξτε ρόλο");
          }

          if (this.empRealtionshipValue.length == 0) {
            reject("Παρακαλώ επιλέξτε σχέση εργασίας");
          }

          if (
            this.contract.contractStartDate === "" ||
            this.contract.contractEndDate === ""
          ) {
            reject("Παρακαλώ συπμληρώστε ολα τα απαραίτητα πεδια ");
          }

          console.log(this.empRealtionshipValue);

          this.completeSubmitForm["relationship"] = this.empRealtionshipValue[
            "id"
          ];
          this.completeSubmitForm["departments"] = this.departmentValue.map(
            (e) => e.id
          );
          this.completeSubmitForm["roles"] = this.roleValue["id"];
          this.completeSubmitForm["secondaryRole"] = this.secondaryRole;
          this.completeSubmitForm["contract"] = this.contract;

          this.startDate = this.contract.contractStartDate;
          this.endDate = this.contract.contractEndDate;

          resolve(true);
        }, 1000);
      });
    },
    validateThirdTab() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.cardNumberErrorMsg) {
            reject(
              "Παρακαλώ εισάγετε μόνο αριθμούς στο πεδιο 'Αριθμος κάρτας'"
            );
          }

          this.completeSubmitForm["devices"] = this.devices.map((e) => e.id);

          if (this.cardNumber) {
            this.completeSubmitForm["card"] = [{ cardNumber: this.cardNumber }];
            if (this.devices.length > 0) {
              isCardNmberExists(this.completeSubmitForm)
                .then((resp) => {
                  if (resp.data.length > 0) {
                    reject("Ο αριθμός κάρτας ανήκει σε άλλον χρήστη.");
                  } else {
                    resolve(true);
                  }
                })
                .catch((error) => {
                  console.log("eimai sto error??");
                  console.log(error);
                  reject("Προέκυψε σφάλμα κατά τον έλεγχο του αριθμού κάρτας.");
                });
            }
          } else {
            reject("Παρακαλώ εισάγετε τον αριθμό κάρτας");
          }

          // resolve(true);
        }, 1000);
      });
    },
    validateFourthTab() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const schedule = this.workingSchedule
            .map((e) => {
              return {
                startTime: e.startTime,
                endTime: e.endTime,
                is_night_shift: e.is_night_shift,
              };
            })
            .filter((o) => o != null);
          schedule.map((e) => {
            if (e.startTime == null || e.endTime == null) {
              reject("Παρακαλώ συπμληρώστε ολα τα απαραίτητα πεδια ");
            }
          });
          if (this.startDate === "" || this.endDate === "") {
            reject("Παρακαλώ συπμληρώστε ολα τα απαραίτητα πεδια ");
          }
          const weekdaysIds = weekDays
            .map((e) => {
              if (this.weekdaySelected.includes(e.weekday)) {
                return e.id + 1;
              }
            })
            .filter((o) => o != null);
          schedule["weekdays"] = weekdaysIds;
          schedule["startDate"] = this.startDate;
          schedule["endDate"] = this.endDate;
          schedule["is_night_shift"] = this.is_night_shift;

          this.completeSubmitForm["schedule"] = schedule;

          resolve(true);
        }, 1000);
      });
    },
  },
};
</script>

<style scoped>
::v-deep .custom-checkbox .form-check-input {
  width: 30px;
  height: 30px;
}
</style>
